/**
 * Turns a server-prefetch prop into a real, never-rejecting `Promise`.
 *
 * Promises streamed from a Server Component arrive in Client Components as React
 * Flight chunks: thenables that inherit `.catch`/`.finally` from
 * `Promise.prototype`, but whose own `.then` returns `undefined`. Chaining on
 * them (`prefetch.catch(...).then(...)`) therefore throws a TypeError, so we
 * only ever call `.then(onFulfilled, onRejected)` on the prop and hand callers a
 * standard Promise. A rejected/failed prefetch resolves to `null`, which the
 * sections treat as "load it yourself".
 */
export function awaitPrefetch<T>(prefetch: PromiseLike<T | null>): Promise<T | null> {
    return new Promise((resolve) => {
        prefetch.then(resolve, () => resolve(null));
    });
}
